import React, { useEffect, useState } from "react";

import { Route } from "react-router-dom";
import {
	createStepper,
	disableAlert,
	STEPPER_STATUS,
} from "../../../components/stepper/dynamicStepper";
import { TECHNICAL_COMMITTEE_ROUTES } from "../../../app/router/routes";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import NavBar from "../../../components/navbar/NavBar";

import { SectionColumn } from "../../../components/section";
import { DASHBOARD_ICONS } from "../../../Helpers/ICONS";
import CertificationBodyReviewStep1 from "../../certificationBody/review/flow/certificationBodyReviewStep1";
import CertificationBodyReviewStep4 from "../../certificationBody/review/flow/certificationBodyReviewStep4";
import CertificationBodyReviewStep5 from "../../certificationBody/review/flow/certificationBodyReviewStep5";

export const stepperName = "TCView";

const TCCBView = () => {
	const stepper = [
		{
			step: "Business Details",
			status: STEPPER_STATUS.COMPLETED,
		},

		{
			step: "Certificates",
			status: STEPPER_STATUS.COMPLETED,
		},
		{ step: "Other Documents", status: STEPPER_STATUS.COMPLETED },
	];
	const [stepperData, setStepperData] = useState();
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setStepperData(createStepper(stepperName, stepper));
		disableAlert();
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	}, []);

	const routeArray = [
		TECHNICAL_COMMITTEE_ROUTES.CBSTEP01,
		TECHNICAL_COMMITTEE_ROUTES.CBSTEP02,
		TECHNICAL_COMMITTEE_ROUTES.CBSTEP03,
	];
	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<NavBar
				stepperName={stepperName}
				title={"Technical Committee Review"}
				tableIcon={DASHBOARD_ICONS.technicalCommittee}
				tableURL={TECHNICAL_COMMITTEE_ROUTES.REVIEW}
			/>

			{stepperData && (
				<SectionColumn className='w-full pt-1'>
					<Route path={TECHNICAL_COMMITTEE_ROUTES.CBSTEP01}>
						<CertificationBodyReviewStep1
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={0}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.CBSTEP02}
							readOnly
							hideFiles={true}
						/>
					</Route>

					<Route path={TECHNICAL_COMMITTEE_ROUTES.CBSTEP02}>
						<CertificationBodyReviewStep4
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={1}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.CBSTEP03}
							readOnly
						/>
					</Route>
					<Route path={TECHNICAL_COMMITTEE_ROUTES.CBSTEP03}>
						<CertificationBodyReviewStep5
							stepperData={stepperData}
							stepperName={stepperName}
							routeArray={routeArray}
							setIsLoading={setIsLoading}
							customIndex={2}
							nextCustomRoute={TECHNICAL_COMMITTEE_ROUTES.REVIEW}
							readOnly
						/>
					</Route>
				</SectionColumn>
			)}
		</div>
	);
};

export default TCCBView;
